import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ASSETS_QUERY_KEY} from "../queryKeys";
import {ReachAsset} from "./types";

type CreateAssetVariables = {name?: string; file?: File; sourceUrl?: string};

const createAsset = async ({name, file, sourceUrl}: CreateAssetVariables): Promise<ReachAsset> => {
  const formData = new FormData();
  if (name) formData.append("name", name);
  if (file) formData.append("file", file);
  if (sourceUrl) formData.append("source_url", sourceUrl);
  const response = await axiosReachInstance.post<ReachAsset, AxiosResponse<ReachAsset>, FormData>(
    "/assets",
    formData,
    {headers: {"Content-Type": "multipart/form-data"}}
  );
  return response.data;
};

export const useCreateAsset = (
  options?: BaseMutationOptions<ReachAsset, CreateAssetVariables>
): BaseUseMutationResult<ReachAsset, CreateAssetVariables> => {
  return useBaseMutation<ReachAsset, CreateAssetVariables>(createAsset, {
    ...options,
    prefixKeysToInvalidate: () => [[ASSETS_QUERY_KEY]],
  });
};
